<script>
    export let windowHeight = 450, windowWidth=600;

</script>

<style>
    .row{
        box-sizing: border-box;
        display: flex;
        flex: 0 1 auto;
        flex-direction: row;
        flex-wrap: wrap;
    }
    .schedule-line{
        font-size: 1.5rem;
    }
    .section-title{
        font-size: 2.92rem;
        line-height: 110%;
        text-align: center
    }
    [class^='col']{
        display: inline-block;
    }
    .col1{
        width: 10%;
    }
    .col2{
        width: 20%;
    }
    .col3{
        width: 30%;
    }
    .col4{
        width: 40%;
    }
    .col5{
        width: 50%;
    }
    .col6{
        width: 60%;
    }
    .col7{
        width: 70%;
    }
    .col8{
        width: 80%;
    }
    .col9{
        width: 90%;
    }
    .col10{
        width: 100%;
    }
    .schedule-container{
        text-align: center;
        min-width: 50%
    }
    @media (min-width: 1000px) and (max-width: 1225px){
        .schedule-container{
            text-align: center;
            min-width: 80%
        }
    }
    @media (max-width: 1225px){
        .schedule-container{
            text-align: center;
            min-width: 100%
        }
    }
</style>

<div class="schedule-container" >
    <div class="marker-text section-title">
        Nos Horaires
    </div>
    <div class="row schedule-line">
        <div class="cursive-text col4">
            Lundi :
        </div>
        <div class="cursive-text col6">
            <div class="col{windowWidth < 768 ? '10' : '6'}">
                Fermé
            </div>
        </div>
    </div>
    <div class="row schedule-line">
        <div class="cursive-text col4">
            Mardi :
        </div>
        <div class="cursive-text col6">
            <div class="col{windowWidth < 768 ? '10' : '3'}">
                11:00 - 14:00
            </div>
            <div class="col{windowWidth < 768 ? '10' : '3'}">
                18:00 - 21:00
            </div>
        </div>
    </div>
    <div class="row schedule-line">
        <div class="cursive-text col4">
            Mercredi :
        </div>
        <div class="cursive-text col6">
            <div class="col{windowWidth < 768 ? '10' : '3'}">
                11:00 - 14:00
            </div>
            <div class="col{windowWidth < 768 ? '10' : '3'}">
                18:00 - 21:00
            </div>
        </div>
    </div>
    <div class="row schedule-line">
        <div class="cursive-text col4">
            Jeudi :
        </div>
        <div class="cursive-text col6">
            <div class="col{windowWidth < 768 ? '10' : '3'}">
                11:00 - 14:00
            </div>
            <div class="col{windowWidth < 768 ? '10' : '3'}">
                18:00 - 21:00
            </div>
        </div>
    </div>
    <div class="row schedule-line">
        <div class="cursive-text col4">
            Vendredi :
        </div>
        <div class="cursive-text col6">
            <div class="col{windowWidth < 768 ? '10' : '3'}">
                11:00 - 14:00
            </div>
            <div class="col{windowWidth < 768 ? '10' : '3'}">
                18:00 - 21:00
            </div>
        </div>
    </div>
    <div class="row schedule-line">
        <div class="cursive-text col4">
            Samedi :
        </div>
        <div class="cursive-text col6">
            <div class="col{windowWidth < 768 ? '10' : '3'}">
                11:00 - 14:00
            </div>
            <div class="col{windowWidth < 768 ? '10' : '3'}">
                18:00 - 21:00
            </div>
        </div>
    </div>
    <div class="row schedule-line">
        <div class="cursive-text col4">
            Dimanche :
        </div>
        <div class="cursive-text col6">
            <div class="col10">
                Fermé
            </div>
        </div>
    </div>
</div>